import React, {Component} from 'react';
import {Form, Control, Errors} from "react-redux-form";
import {isRequired, minValue, required} from "../field_validations";
import {toInt} from "../parsers";
import _ from "lodash";

export default class AmountAgencyEditForm extends Component{
	render(){
		let {amounts_agencies, entities, versions, modalities} = this.props;
		return (
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="amounts_agencies.edit" onSubmit={(values) => this._submitForm(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>

						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="version_id" className="label">Año <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select
										model=".version_id"
										id="version_id"
										className="select" errors={{required}} validateOn="change" parser={ toInt }>
										<option value=" " defaultValue>--- Año ---</option>
										{_.map(versions.list,(version, k) => {
											return <option value={version.id} key={k}>{version.year}</option>
										})}
									</Control.select>
								</div>
								<Errors
									model=".version_id"
									wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>}
									messages={{ required: 'Debes elegir una año.'}} />
							</div>

							<div className="control">
								<label htmlFor="modality_id" className="label">Categoría <span className="small has-text-danger">*</span></label>
								<div className="select" >
									<Control.select
										model=".modality_id"
										id="modality_id"
										parser={ toInt }
										changeAction={(model, value) => this._modalityChange(model,value)}
										errors={{required}}
										validateOn="change">
										<option value=" " defaultValue>--- Categoría ---</option>
										{_.map(modalities.list,(option, k) => {
											return <option value={option.id} key={k}>{option.name}</option>
										})}
									</Control.select>
								</div>
								<Errors
									model=".modality_id"
									show="touched"
									wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>}
									messages={{ required: 'Debes seleccionar una modalidad.' }} />
							</div>

							<div className="control">
								<label htmlFor="expenses_percent" className="label">Porcentaje de gasto Maximo <span className="small has-text-danger">*</span></label>
								<div className="control has-icons-left">
									<Control.text
										model=".expenses_percent"
										type="number" step={1} min={1} max={100}
										className="input"
										errors={{isRequired, minValue: minValue(0)}}
										validateOn="change"/>
									<span className="icon is-small is-left">
								      <i className="fa fa-percent"></i>
								    </span>
								</div>
								<Errors
									model=".expenses_percent"
									show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>}
									messages={{ isRequired: 'Se requiere una cantidad',minValue: 'Cantidad minima no admitida.'}} />
							</div>

							<div className="control">
								<div className="field">
									<label htmlFor="amount_max" className="label">Monto <span className="small has-text-danger">*</span></label>
									<div className="control has-icons-left">
										<Control.text
											model=".amount_max"
											id="amount_max"
											className="input"
											type="number" step=".01" min="0"
											errors={{isRequired, minValue: minValue(0)}}
											validateOn="change"/>
										<span className="icon is-small is-left"><i className="fa fa-usd"/></span>
										<Errors
											model=".amount_max"
											show="touched"
											wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>}
											messages={{ isRequired: 'Se requiere una cantidad',minValue: 'Cantidad minima no admitida.'}} />
									</div>
								</div>
							</div>
						</div>

						{amounts_agencies.edit.modality_id !== 2 ?
						<div className="field is-grouped">
							<div className={`control`}>
								<label htmlFor="state" className="label">Estado <span className="small has-text-danger">*</span></label>
								<div className={`select`}>
									<Control.select
										model=".state_id"
										id="state"
										value={amounts_agencies.edit.state_id ? amounts_agencies.edit.state_id:''}
										//changeAction={(model, value) => this.changeMuns(model, value)}
										parser={toInt}
										errors={{required}}
										validateOn="change"
									>
										<option defaultValue={entities.isFetching}>--- Estado ---</option>
										{entities.list.map((option, key) => {
											return <option key={key} value={option.id}>{option.name}</option>
										})}
									</Control.select>
								</div>
								<Errors
									model=".state_id"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{required: 'El estado es obligatorio'}}
								/>
							</div>

							{amounts_agencies.edit.modality_id === 3 ?
								<div className="control">
									<label htmlFor="agencies_max" className="label">Maximo CDMS <span className="small has-text-danger">*</span></label>
									<Control.text
										model=".agencies_max"
										type="number" step={1} min={1}
										className="input"
										errors={{isRequired, minValue: minValue(1)}}
										validateOn="change"/>
									<Errors
										model=".amount_max"
										show="touched"
										wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>}
										messages={{ isRequired: 'Se requiere una cantidad',minValue: 'Cantidad minima no admitida.'}} />
								</div>:''}
						</div>:''}

						<div className="field is-grouped is-grouped-right" >
							<div className="control">
								<button type="button" className="button is-large"  onClick={() => this.props.history.push('/instancias/montos')}>
									Regresar
								</button>
							</div>

							<div className="control">
								<Control.button
									model="amounts_agencies.edit" className="button is-primary is-large">
									Guardar
								</Control.button>
							</div>
						</div>
					</Form>
				</div>
			</div>
		)
	}

	_submitForm(values) {
		//console.log('values: ',values);
		this.props.amountsAgenciesEditSave(values);
	}

	componentWillMount(){
		const {amounts_agencies} = this.props;
		if(!_.isEmpty(amounts_agencies.edit) && amounts_agencies.edit.state_id){
			//this.props.fetchMunicipalities(amounts_agencies.edit.state_id);
		}
	}


	_modalityChange(model,value){
		this.props.change(model,value);
		this.props.change('amounts_agencies.edit.state_id',undefined);
		this.props.change('amounts_agencies.edit.agencies_max',undefined);
	}
}


// WEBPACK FOOTER //
// ./src/elements/agencies/amounts_form.jsx